module.exports = __webpack_public_path__ + "static/media/hazardgoods_legend.d9871cef.svg";